import React from "react";
import classes from "./Shared.module.scss";

const phEvenText = (props) => {
  return (
    <p className={[classes.phText, classes[props.where], classes[props.color]].join(' ')}>
     Registration and additional tickets for the {props.runYear} Emerald Coast Poker Run are not available at this time.
     We will update this page when registration opens again.
    </p>
  );
}
phEvenText.defaultProps = {
  runYear: 'upcoming',
  color: 'def'
}
export default phEvenText;